import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { AuthState, AuthUser, User } from "./auth.types";

const initialState: AuthState = {
    showTenantSwitcher: false,
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setShowTenantSwitcher: (state, action: PayloadAction<boolean>) => {
            state.showTenantSwitcher = action.payload;
        },
        setAuthUser: (state, action: PayloadAction<AuthUser | undefined>) => {
            state.user = action.payload;
        },
    },
});

export const { setShowTenantSwitcher, setAuthUser } = authSlice.actions;

export const selectAuthUser = (state: RootState) => state.auth.user;
export const authSelector = (state: RootState) => !!state.auth.user;
export const hasPermission = (state: RootState, permission: string) =>
    !!state.auth.user && state.auth.user.permissions.includes(permission);

export const selectSessionUser = createSelector([selectAuthUser], (authUser) =>
    authUser ? new User(authUser) : undefined
);
export default authSlice.reducer;
